import { CurrencyAmount, Token } from '@kodiak-finance/sdk-core'
import { ButtonPrimary } from 'components/Button'
import Column from 'components/Column'
import CurrencyInputPanel from 'components/CurrencyInputPanel'
import { useStepLineStateUpdate } from 'components/StepLine/context/StepLineContext'
import { XKDK_ADDRESSES } from 'constants/addresses'
import { useToken } from 'hooks/Tokens'
import { useConnection } from 'hooks/useConnection'
import { useTokenBalance } from 'lib/hooks/useCurrencyBalance'
import tryParseCurrencyAmount from 'lib/utils/tryParseCurrencyAmount'
import { useMemo, useState } from 'react'

import { REFETCH_POLICY_FAST } from '../../config/RefetchPolicies'

export type AllocationStepState = {
  amount: CurrencyAmount<Token> | undefined
}

const AllocateViewStep = ({ next }: { next: () => void }) => {
  const [inputKdk, setInputKdk] = useState('')
  const { chainId } = useConnection()
  const xKdkAddress = XKDK_ADDRESSES[chainId]
  const xKdkToken = useToken(xKdkAddress)
  const update = useStepLineStateUpdate<AllocationStepState>()

  const amount = useMemo(() => {
    const amount = tryParseCurrencyAmount(inputKdk, xKdkToken || undefined)
    update({ amount })
    return amount
  }, [inputKdk, xKdkToken])

  const { account } = useConnection()
  const balance = useTokenBalance(account, xKdkToken || undefined, REFETCH_POLICY_FAST)
  const isInsufficientBalance = Boolean(amount && balance && amount.greaterThan(balance))
  const isActionDisabled = !amount || !amount.greaterThan('0') || !balance || isInsufficientBalance
  const actionLabel = isInsufficientBalance ? 'Insufficient xKDK' : 'Stake'

  return (
    <Column width="100%" gap="8px">
      <CurrencyInputPanel
        // hideBalance={true}
        value={inputKdk}
        onUserInput={setInputKdk}
        onMax={() => setInputKdk(balance?.toExact() ?? '0')}
        showMaxButton={true}
        currency={xKdkToken}
        label="kdk"
        id="convert-kdk"
      />
      <ButtonPrimary disabled={isActionDisabled} onClick={next}>
        {actionLabel}
      </ButtonPrimary>
    </Column>
  )
}

export default AllocateViewStep
